import { FormControl, Validators } from '@angular/forms';
import { containsNumberValidator } from '../custom-validators/contains-number.validator';
import { containsSpecialCharactersValidator } from '../custom-validators/contains-special-characters.validator';

export class CreatePasswordComponent {

  public viewNewPassword: boolean = false;
  public viewConfirmPassword: boolean = false;

  public isConfirmPasswordCapsLockOn: boolean = false;
  public isNewPasswordCapsLockOn: boolean = false;

  public newPassword: FormControl = new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(32), containsNumberValidator, containsSpecialCharactersValidator]);
  public confirmPassword: FormControl = new FormControl('', [Validators.required]);

  public toggleNewPasswordVisibility() {
    this.viewNewPassword = !this.viewNewPassword;
  }

  public toggleConfirmPasswordVisibility() {
    this.viewConfirmPassword = !this.viewConfirmPassword;
  }

  public displayConfirmPasswordCapsLockOn($event) {
    this.isConfirmPasswordCapsLockOn = $event;
  }

  public displayNewPasswordCapsLockOn($event) {
    this.isNewPasswordCapsLockOn = $event;
  }
}
